// src/components/Reveal.jsx
// Scroll-triggered fade-in + slide-up animation component.
// Wraps any content and animates it when it enters the viewport.
import { useEffect, useRef } from 'react';

export default function Reveal({ children, delay = 0, as = 'div', className = '', style = {} }) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          el.classList.add('is-visible');
          observer.unobserve(el);
        }
      },
      { threshold: 0.1, rootMargin: '0px 0px -32px 0px' }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, []);

  const Tag = as;
  return (
    <Tag
      ref={ref}
      className={`reveal${className ? ` ${className}` : ''}`}
      style={{ '--reveal-delay': `${delay}ms`, ...style }}
    >
      {children}
    </Tag>
  );
}
